import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-[#F5F7FB]" data-id="element-50" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-51" data-mp="1cf9ka81chzg0">
        <div className="text-center mb-16" data-id="element-52" data-mp="1cgb719rq4adk">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#081632]" data-id="element-53" data-mp="2a2s3ydwjolys">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-54" data-mp="253x9gep7t8yu">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-[#D89B16]/40 rounded-xl overflow-hidden shadow-sm shadow-[#1E4ED8]/10" data-id="element-55" data-mp="202rgqgvk1lpb" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#1E4ED8]" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-56" data-mp="op5ub3h2xy7h">
                <span className="font-bold text-lg text-[#081632] pr-8" data-id="element-57" data-mp="1apstar7dhf88">{faq.q}</span>
                <ChevronDown className={`text-[#D89B16] transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" data-mp="1fonaxptlsxqr" />
              </button>
              <AnimatePresence initial={false} data-id="element-59" data-mp="16oqto99jn15q">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-60" data-mp="s0dvr6qwb88l">
                    <div className="px-6 pb-5 text-slate-600 border-t border-[#D89B16]/30 pt-4" data-id="element-61" data-mp="n1stz2vzwgi1">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}